import * as Yup from 'yup';

export default Yup.object().shape({
  agreedToTerms: Yup.date()
    .required('You must agree to the terms and conditions')
    .typeError('You must agree to the terms and conditions'),
});
